import * as React from 'react';
import { Button } from 'semantic-ui-react';
import { autobind } from 'core-decorators';
import { DATA_TEST_ID } from '../data-test-id';
import './error-page.less';
export interface IErrorPageProps {
  headerText?: string;
  subheaderText?: string;
  redirectLink?: any;
  redirectText?: string;
  history?: any;
}

export class ErrorPage extends React.Component<IErrorPageProps, {}> {
  public static defaultProps: Partial<IErrorPageProps> = {
    headerText: 'Whoops!',
    subheaderText: 'It appears that this page does not exist',
    redirectText: 'Back to safety'
  };
  constructor(props: IErrorPageProps) {
    super(props);
  }

  @autobind
  public handleGoBack(): void {
    this.props.history.go(-3);
  }

  public render(): JSX.Element {
    return (
      <div data-component="error-page" data-test-id={DATA_TEST_ID.ERROR_PAGE}>
        <h1>{this.props.headerText}</h1>
        <p>{this.props.subheaderText}</p>
        <Button
          inverted
          onClick={this.handleGoBack}
        >
          {this.props.redirectText}
        </Button>
      </div>
    );
  }
}
